import React from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL = 200;
const LEFT = 17;
export function ScarcityBar() {
  const filled = Math.round((TOTAL - LEFT) / TOTAL * 100);
  return <div className="mt-6 w-full max-w-md rounded-2xl border border-amber-300/70 bg-amber-50 px-4 py-4" data-id="element-48" data-mp="2l565qm2bfdwy">
      <p className="flex items-center justify-center gap-1.5 text-center text-[11px] sm:text-xs font-extrabold uppercase tracking-wide text-amber-700" data-id="element-49" data-mp="2q3r8ot8ycbp3">
        <FlameIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-50" data-mp="2b5fa2h20qsva" />
        Solo quedan {LEFT} cupos al precio promocional
      </p>
      <div className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-amber-200" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={filled} aria-label="Cupos ocupados al precio promocional" data-id="element-51" data-mp="2g3gup6f3f08v">
        <div className="h-full rounded-full bg-brandred transition-[width] duration-700" style={{
        width: `${filled}%`
      }} data-id="element-52" data-mp="f8e0h5homt2" />
      </div>
      <p className="mt-2 text-center text-[11px] font-semibold text-amber-800/80" data-id="element-53" data-mp="33md5n8t5s6qy">
        {TOTAL - LEFT} de {TOTAL} cupos ya reclamados
      </p>
    </div>;
}